module.exports = __webpack_public_path__ + "images/psp/MilitaryIcons/MilitarySizeChartOne/iconFour.svg";